<template>
    <div>
        <!--<DocumentDialog v-model="showDialog" type='download' :data=documentData :document_access="document_access"-->
                        <!--@close="clickClose()"-->
                        <!--@cancel="clickCancel()" @confirm="clickConfirm()"></DocumentDialog>-->
        <Library :data="temp" @message_back="message_back"></Library>
        <div v-if="docs.length>0" class="document_div">
            <div class="libary_main_libray_content_cards">
                <div class="libray_main_library_content_card" v-for="md in docs" :key="md.id">
                    <div @click="openDocumentDialog(md)">
                        <LibraryCard :data="md"></LibraryCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import courseApi from '@/api/courses/course_information.js'
    import documentApi from '@/api/document/document.js'
    import LibraryCard from '@/components/common_components/cards/library_card.vue'
    import Library from '@/components/library_page/library_item.vue'

    export default {
        name: "document",
        data() {
            return {
                'docs': [],
                showDialog: false,
                document_access: false,
                documentData: null,
                temp:''
            }
        },
        components: {
            LibraryCard,
            Library,
        },
        methods: {
            openDocumentDialog(doc) {
                console.log('click',doc)
                this.temp = String(doc.id)
            },
            message_back(){
                this.temp = ''
            }
        },
        mounted() {
            let args = {
                'course_id': this.$route.params.id,
            }
            courseApi.get_course_document(args).then(res => {
                console.log(res)
                this.docs = res.data.docs
            })

        }
    }
</script>

<style scoped>
    .libary_main_libray_content_cards {
        display: flex;
        flex-wrap: wrap;
    }

    .libray_main_library_content_card {
        width: 33%;
        padding: 0 5px;
    }
</style>